import React, { useEffect } from 'react'
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import './my-momentum-list.styles.scss';
import PlayerRecordsList from '@/components/SHARED/player-records-list/player-records-list.component';

const MyMomentumList = ({
  gameData,
  playerData,
  gameElements
}) => {

  useEffect(() => {
    if (!gameData?.gameName) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText = 'Momentum Cards';
    }
    changeDocumentTitle(`Momentum Cards | ${gameData?.gameName}`);
  }, [gameData?.gameName])

  return (
    <div className='momentum-cards-list'>
      <PlayerRecordsList
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
        activityType='momentum'
        title='Momentum Cards'
        summaryLabel='Momentum Cards Drawn'
        summaryIcon='/images/icons/momentum2.png'
        emptyText='No momentum cards yet...' />
    </div>
  )
}

export default MyMomentumList
